import React from 'react';
import Badge from './Badge';

const STATUS_TONES = {
  DRAFT: 'neutral',
  SUBMITTED: 'info',
  IN_REVIEW: 'info',
  APPROVED: 'success',
  REJECTED: 'danger',
  REVISION_REQUESTED: 'warning',

  SENT: 'info',
  PARTIAL: 'warning',
  PAID: 'success',
  OVERDUE: 'danger',
  CANCELLED: 'neutral',

  PENDING: 'warning',
  SUCCESS: 'success',
  FAILED: 'danger',
  REFUNDED: 'neutral',

  PROCESSED: 'info',
  LOCKED: 'warning',

  AVAILABLE: 'success',
  ASSIGNED: 'info',
  MAINTENANCE: 'warning',
  RETIRED: 'neutral',

  ACTIVE: 'success',
  INACTIVE: 'neutral',
};

export default function StatusPill({ value, tone, children }) {
  if (!value && !children) return <span className="text-ink-faint">—</span>;
  const resolved = tone || STATUS_TONES[String(value).toUpperCase()] || 'neutral';
  return (
    <Badge tone={resolved}>
      {children ?? String(value).replace(/_/g, ' ')}
    </Badge>
  );
}
